module.exports = __webpack_public_path__ + "img/stats.9c0a6f7.webp";